(() => {
  "use strict";
  const CFG = window.LYMKO || {};
  const TX = CFG.t || {};
  const T = (k, d, o) => String(TX[k] || d).replace(/\[(\w+)\]/g, (m, x) => o && x in o ? o[x] : m);
  const R = CFG.routes || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", search: "/search", predictive: "/search/suggest" };
  const U = (p) => (R.root.endsWith("/") ? R.root : R.root + "/") + p;
  const MAXQ = Number(CFG.maxQty) || 20;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const store = {
    get(k, d) {
      try {
        const v = localStorage.getItem(k);
        return v ? JSON.parse(v) : d;
      } catch (e) {
        return d;
      }
    },
    set(k, v) {
      try {
        localStorage.setItem(k, JSON.stringify(v));
      } catch (e) {
      }
    }
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  function money(cents) {
    const fmt = CFG.moneyFormat || "₹{{amount_no_decimals}}";
    const n = Number(cents) / 100;
    const f = (d, t = ",", dec = ".") => {
      const [i, frac] = n.toFixed(d).split(".");
      const iso = i.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + t);
      return frac ? iso + dec + frac : iso;
    };
    const indian = (v) => {
      const [i, frac] = v.toFixed(0).split(".");
      const last3 = i.slice(-3), rest = i.slice(0, -3);
      return (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," : "") + last3 + (frac ? "." + frac : "");
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case "amount":
          return Number.isInteger(n) ? indian(n) : f(2);
        case "amount_no_decimals":
          return indian(Math.round(n));
        case "amount_with_comma_separator":
          return f(2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return f(0, ".", ",");
        default:
          return f(2);
      }
    });
  }
  let toastT;
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove("on"), 2600);
  }
  const hideLd = () => {
    const l = $("#ld");
    if (l) l.classList.add("gone");
  };
  addEventListener("load", () => setTimeout(hideLd, 500));
  setTimeout(hideLd, 2200);
  let io;
  function reveal(root = document) {
    if (!("IntersectionObserver" in window)) {
      $$(".rv", root).forEach((e) => e.classList.add("in"));
      return;
    }
    io = io || new IntersectionObserver((es) => es.forEach((en) => {
      if (en.isIntersecting) {
        en.target.classList.add("in");
        io.unobserve(en.target);
      }
    }), { threshold: 0.08, rootMargin: "0px 0px -30px 0px" });
    $$(".rv:not(.in)", root).forEach((el) => io.observe(el));
  }
  function onScroll() {
    const h = $("#hdr");
    if (h) h.classList.toggle("sc", scrollY > 8);
    const st = $("[data-stmt]");
    if (st) {
      const W = $$(".wd", st);
      const r = st.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.3)));
      const n = Math.round(p * W.length);
      W.forEach((w, i) => w.classList.toggle("lit", i < n));
    }
  }
  addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (a && a.origin === location.origin && !a.hasAttribute("data-open") && !e.metaKey && !e.ctrlKey && a.target !== "_blank" && !a.getAttribute("href").startsWith("#")) {
      const rb = $("#rbar");
      if (rb) {
        rb.classList.remove("go");
        void rb.offsetWidth;
        rb.classList.add("go");
      }
    }
  });
  const PANELS = { cart: "#dcart", search: "#dsearch", menu: "#dmenu" };
  let OPEN = null, lastFocus = null;
  function openO(k) {
    const o = $(PANELS[k]);
    if (!o) return false;
    if (OPEN && OPEN !== k) closeAll(true);
    lastFocus = document.activeElement;
    OPEN = k;
    if (k === "search") {
      renderRecent();
      const q = $("#oq");
      predictive(q ? q.value : "");
      if (window.Lymko && window.Lymko.S) window.Lymko.S.load().catch(() => {
      });
    }
    o.classList.add("on");
    o.setAttribute("aria-hidden", "false");
    if (k !== "search") $("#scrim").classList.add("on");
    document.body.classList.add("ov");
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      const f = k === "search" ? $("#oq") : $("[data-close]", o);
      if (f) f.focus({ preventScroll: true });
    }, k === "search" ? 350 : 80);
    return true;
  }
  function closeAll(keep) {
    Object.values(PANELS).forEach((s) => {
      const o = $(s);
      if (o) {
        o.classList.remove("on");
        o.setAttribute("aria-hidden", "true");
      }
    });
    const f = $("#filt");
    if (f) f.classList.remove("on");
    const sc = $("#scrim");
    if (sc) sc.classList.remove("on");
    document.body.classList.remove("ov");
    document.body.style.overflow = "";
    OPEN = null;
    if (!keep && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && (OPEN || $("#scrim") && $("#scrim").classList.contains("on"))) closeAll();
    if (e.key === "Tab" && OPEN) {
      const o = $(PANELS[OPEN]);
      const f = $$("a[href],button:not([disabled]),input:not([type=hidden]),select,textarea", o).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) {
        e.preventDefault();
        z.focus();
      } else if (!e.shiftKey && document.activeElement === z) {
        e.preventDefault();
        a.focus();
      }
    }
  });
  const cartPageSection = () => {
    const c = $("[data-cart-page]");
    const s = c && c.closest(".shopify-section");
    return s ? s.id.replace("shopify-section-", "") : null;
  };
  function sectionsParam() {
    const s = ["cart-drawer"];
    const cp = cartPageSection();
    if (cp) s.push(cp);
    return s.join(",");
  }
  function applySections(sections) {
    if (!sections) return;
    /* LK-KEEP-SCROLL (2026-10-14): the bag list is re-drawn after every +/−, remove or add, which used to jump the
       list back to the top. The scroll position of the bag list (and of the page) is kept, so the shopper stays on
       the product they just changed. */
    const db0 = $("#dcart .dr-b"), dbTop = db0 ? db0.scrollTop : 0, pageY = scrollY;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      if (id === "cart-drawer") {
        const n = $("#dcart"), f = doc.querySelector("#dcart");
        if (n && f) n.innerHTML = f.innerHTML;
      } else {
        const n = document.getElementById("shopify-section-" + id), f = doc.getElementById("shopify-section-" + id);
        if (n && f) n.innerHTML = f.innerHTML;
      }
    });
    const keep = () => {
      const db = $("#dcart .dr-b");
      if (db && dbTop) db.scrollTop = dbTop;
      if (Math.abs(scrollY - pageY) > 1 && !document.body.classList.contains("ov")) scrollTo(scrollX, pageY);
    };
    keep();
    requestAnimationFrame(keep);
    reveal();
    markFavs();
  }
  function setCount(n) {
    $$("[data-cc]").forEach((b) => {
      b.textContent = n;
      b.classList.toggle("on", n > 0);
      b.classList.remove("bump");
      void b.offsetWidth;
      b.classList.add("bump");
    });
    $$("[data-cc2]").forEach((b) => b.textContent = n);
    const bl = $(".tools [data-open=cart]");
    if (bl) bl.setAttribute("aria-label", n === 1 ? T("open_bag_one", "Open bag, 1 item") : T("open_bag", "Open bag, [n] items", { n }));
  }
  async function refreshCount() {
    try {
      const c = await (await fetch(U("cart.js"), { headers: { Accept: "application/json" } })).json();
      setCount(c.item_count);
      return c;
    } catch (e) {
      return null;
    }
  }
  async function addItems(items) {
    const res = await fetch(R.cartAdd + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items, sections: sectionsParam(), sections_url: location.pathname }) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T("add_failed", "Could not add to bag"));
    applySections(data.sections);
    refreshCount();
    return data;
  }
  async function changeLine(line, quantity) {
    let res;
    try {
      res = await fetch(R.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Math.min(MAXQ, Number(quantity))), sections: sectionsParam(), sections_url: location.pathname }) });
    } catch (e) {
      toast(T("update_failed", "Could not update your bag"));
      return false;
    }
    let data = {};
    try {
      data = await res.json();
    } catch (e) {
    }
    if (!res.ok || data.status) {
      toast(data.description || data.message || T("update_failed", "Could not update your bag"));
      return false;
    }
    applySections(data.sections);
    setCount(data.item_count);
    return true;
  }
  async function refreshCartSections() {
    const res = await fetch(`${location.pathname}?sections=${sectionsParam()}`);
    if (res.ok) applySections(await res.json());
    await refreshCount();
  }
  document.addEventListener("submit", async (e) => {
    const f = e.target.closest("[data-promo]");
    if (!f) return;
    e.preventDefault();
    const input = f.querySelector("input[name=discount]") || document.querySelector(`input[form="${f.id}"]`);
    const code = (input && input.value || "").trim();
    const msg = (f.nextElementSibling && f.nextElementSibling.classList.contains("pmsg") ? f.nextElementSibling : null) || input && input.closest(".promo") && input.closest(".promo").nextElementSibling;
    if (!code) {
      if (msg) {
        msg.className = "pmsg err";
        msg.textContent = T("promo_empty", "Please enter a promo code.");
      }
      return;
    }
    try {
      await fetch(U(`discount/${encodeURIComponent(code)}`), { credentials: "same-origin" });
    } catch (err) {
    }
    if (msg) {
      msg.className = "pmsg";
      msg.textContent = T("promo_saved", "“[code]” saved — it’s applied at checkout if it’s valid for your bag.", { code: code.toUpperCase() });
    }
    refreshCartSections();
  });
  let WL = store.get("lk_wl", []);
  function markFavs() {
    $$("[data-fav]").forEach((b) => {
      const on = WL.includes(b.dataset.fav);
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on);
      if (b.id === "pwl") {
        const s = b.querySelector("span");
        if (s) s.textContent = on ? T("wl_saved_btn", "Saved to wishlist") : T("wl_save_btn", "Save to wishlist");
      }
    });
    $$("[data-wc]").forEach((b) => {
      b.textContent = WL.length;
      b.classList.toggle("on", WL.length > 0);
    });
  }
  const cardCache = {};
  const miniCache = {};
  async function fetchCard(handle, mini) {
    const cache = mini ? miniCache : cardCache;
    if (handle in cache) return cache[handle];
    let res;
    try {
      res = await fetch(U(`products/${encodeURIComponent(handle)}?view=card`));
    } catch (e) {
      return null;
    }
    if (!res.ok) {
      cache[handle] = null;
      return null;
    }
    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const card = doc.querySelector(".card"), mc = doc.querySelector("[data-mini] .mcard");
    cardCache[handle] = card ? card.outerHTML : null;
    miniCache[handle] = mc ? mc.outerHTML : null;
    return cache[handle];
  }
  async function renderWishlist() {
    const g = $("#wlgrid");
    if (!g) return;
    const empty = $("#wlempty"), mv = $("#mvall"), cnt = $("#wlcount"), head = $("#wlhead");
    if (head) head.hidden = !WL.length;
    g.hidden = !WL.length;
    if (!WL.length) {
      g.innerHTML = "";
      empty.hidden = false;
      mv.hidden = true;
      if (cnt) cnt.textContent = T("wl_note", "Saved items are stored on this device.");
      return;
    }
    empty.hidden = true;
    mv.hidden = false;
    if (cnt) cnt.textContent = WL.length > 1 ? T("wl_count", "[n] saved items · stored on this device.", { n: WL.length }) : T("wl_count_one", "[n] saved item · stored on this device.", { n: WL.length });
    const cards = await Promise.all(WL.map((h) => fetchCard(h)));
    const valid = WL.filter((h, i) => cards[i]);
    if (valid.length !== WL.length) {
      WL = valid;
      store.set("lk_wl", WL);
      markFavs();
    }
    g.innerHTML = cards.filter(Boolean).map((c, i) => `<div class="wli">${c}<button type="button" class="btn btn-l sm" data-mv="${esc(valid[i])}">${esc(T("move_to_bag", "Move to bag"))}</button></div>`).join("");
    reveal(g);
    markFavs();
  }
  function variantFromCard(el) {
    const b = el && el.querySelector("[data-add]");
    return b ? b.dataset.add : null;
  }
  async function recentlyViewed() {
    let rv = store.get("lk_rv", []);
    if (CFG.handle) {
      rv = [CFG.handle, ...rv.filter((h) => h !== CFG.handle)].slice(0, 12);
      store.set("lk_rv", rv);
    }
    const box = $("[data-recently-viewed]");
    if (!box) return;
    const list = rv.filter((h) => h !== CFG.handle).slice(0, 8);
    if (!list.length) return;
    const cards = (await Promise.all(list.map((h) => fetchCard(h, true)))).filter(Boolean);
    if (!cards.length) return;
    box.innerHTML = `<div class="sh"><h2 class="h2" style="font-size:clamp(26px,3vw,40px)">${T("recently_html", "Recently <em>viewed.</em>")}</h2></div><div class="rv-strip">${cards.join("")}</div>`;
    reveal(box);
    markFavs();
  }
  document.addEventListener("click", async (e) => {
    const skip = e.target.closest(".skip");
    if (skip) {
      e.preventDefault();
      const m = $("#MainContent");
      if (m) m.focus();
      return;
    }
    const o = e.target.closest("[data-open]");
    if (o) {
      if (openO(o.dataset.open)) e.preventDefault();
      return;
    }
    if (e.target.closest("[data-close]")) {
      if (!e.target.closest("a[href]")) e.preventDefault();
      closeAll();
      return;
    }
    if (e.target.closest("#scrim")) {
      closeAll();
      return;
    }
    const add = e.target.closest("[data-add]");
    if (add && add.dataset.add) {
      e.preventDefault();
      e.stopPropagation();
      const inDrawer = !!add.closest("#dcart");
      const orig = add.innerHTML;
      add.disabled = true;
      add.classList.add("busy");
      add.setAttribute("aria-busy", "true");
      try {
        await addItems([{ id: Number(add.dataset.add), quantity: 1 }]);
        if (add.hasAttribute("data-openbag") || inDrawer) {
          if (!inDrawer) openO("cart");
        } else {
          add.classList.add("ok");
          add.innerHTML = T("added_btn", "Added ✓");
          setTimeout(() => {
            add.classList.remove("ok");
            add.innerHTML = orig;
          }, 1500);
        }
      } catch (err) {
        toast(err.message);
      }
      add.classList.remove("busy");
      add.removeAttribute("aria-busy");
      add.disabled = false;
      return;
    }
    const line = e.target.closest("[data-line][data-q]");
    if (line) {
      e.preventDefault();
      line.disabled = true;
      line.classList.add("busy");
      const okc = await changeLine(line.dataset.line, line.dataset.q);
      if (!okc && document.contains(line)) {
        line.disabled = false;
        line.classList.remove("busy");
      }
      return;
    }
    const fav = e.target.closest("[data-fav]");
    if (fav) {
      e.preventDefault();
      e.stopPropagation();
      const h = fav.dataset.fav;
      WL = WL.includes(h) ? WL.filter((x) => x !== h) : [...WL, h];
      store.set("lk_wl", WL);
      markFavs();
      $$("[data-wc]").forEach((b) => {
        b.classList.remove("bump");
        void b.offsetWidth;
        b.classList.add("bump");
      });
      toast(WL.includes(h) ? T("wl_added", "Saved to your wishlist") : T("wl_removed", "Removed from your wishlist"));
      if ($("#wlgrid")) renderWishlist();
      return;
    }
    const mv = e.target.closest("[data-mv]");
    if (mv) {
      const v = variantFromCard(mv.closest(".wli"));
      try {
        if (v) await addItems([{ id: Number(v), quantity: 1 }]);
        WL = WL.filter((x) => x !== mv.dataset.mv);
        store.set("lk_wl", WL);
        markFavs();
        renderWishlist();
        toast(T("moved", "Moved to your bag"));
      } catch (err) {
        toast(err.message);
      }
      return;
    }
    if (e.target.closest("#mvall")) {
      const items = $$("#wlgrid .wli").map(variantFromCard).filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      try {
        if (!items.length) {
          toast(T("wl_none", "Nothing in your wishlist is available right now."));
          return;
        }
        await addItems(items);
        const moved = $$("#wlgrid .wli").filter((x) => variantFromCard(x)).map((x) => x.querySelector("[data-mv]").dataset.mv);
        WL = WL.filter((h) => !moved.includes(h));
        store.set("lk_wl", WL);
        markFavs();
        renderWishlist();
        openO("cart");
      } catch (err) {
        toast(err.message);
      }
      return;
    }
    const sq = e.target.closest("[data-sq]");
    if (sq) {
      e.preventDefault();
      const q = $("#oq");
      if (q) {
        q.value = sq.dataset.sq;
        saveRecent(sq.dataset.sq);
        predictive(sq.dataset.sq);
        renderRecent();
      }
      return;
    }
    if (e.target.closest("#rclear")) {
      store.set("lk_recent", []);
      renderRecent();
      return;
    }
    const sv = e.target.closest("[data-sv]");
    if (sv) saveRecent(sv.dataset.sv);
    if (e.target.closest("#dmenu a[href], #dsearch a[href]")) closeAll(true);
    if (e.target.closest("[data-toggle-recover]")) {
      e.preventDefault();
      const r = $("#recover");
      if (r) r.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" });
    }
  });
  const saveRecent = (v) => {
    v = (v || "").trim();
    if (v.length < 2) return;
    const r = store.get("lk_recent", []);
    store.set("lk_recent", [v, ...r.filter((x) => x.toLowerCase() !== v.toLowerCase())].slice(0, 6));
  };
  function renderRecent() {
    const box = $("#orecent");
    if (!box) return;
    const r = store.get("lk_recent", []);
    box.innerHTML = r.length ? `<h5>${esc(T("recent", "Recent searches"))}</h5><div class="lst">${r.map((x) => `<button type="button" data-sq="${esc(x)}">${esc(x)}<span aria-hidden="true">↗</span></button>`).join("")}<button type="button" id="rclear" style="color:var(--or);font-size:13px">${esc(T("clear_recent", "Clear recent"))}</button></div><div style="height:24px"></div>` : "";
  }
  let pT, pCtl;
  function predictive(q) {
    const out = $("#ores");
    if (!out) return;
    q = (q || "").trim();
    clearTimeout(pT);
    if (pCtl) {
      pCtl.abort();
      pCtl = null;
    }
    const S = window.Lymko && window.Lymko.S;
    if (S && S.on) {
      if (S.ready()) {
        S.overlay(q);
        return;
      }
      S.load().then(() => {
        const c = $("#oq");
        if (c && c.value.trim() === q) S.overlay(q);
      }).catch(() => {
      });
    }
    if (!q) {
      const t = $("#otrend");
      out.innerHTML = t ? t.innerHTML : "";
      return;
    }
    pT = setTimeout(async () => {
      try {
        if (pCtl) pCtl.abort();
        pCtl = new AbortController();
        const url = `${R.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body`;
        const ctl = pCtl;
        const res = await fetch(url, { signal: ctl.signal });
        if (!res.ok) return;
        const html = await res.text();
        const cur = $("#oq");
        if (ctl !== pCtl || cur && cur.value.trim() !== q) return;
        if (S && S.on && S.ready()) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const s = doc.querySelector("#shopify-section-predictive-search");
        out.innerHTML = s ? s.innerHTML : "";
      } catch (err) {
      }
    }, 180);
  }
  const oq = $("#oq");
  if (oq) {
    let rt;
    oq.addEventListener("input", () => {
      predictive(oq.value);
      clearTimeout(rt);
      rt = setTimeout(() => saveRecent(oq.value), 1500);
    });
    oq.form.addEventListener("submit", () => saveRecent(oq.value));
  }
  const nf = $("#nf");
  if (nf) {
    nf.noValidate = true;
    const em = $("#nem", nf), msg = $("#nmsg", nf);
    nf.addEventListener("submit", (e) => {
      const v = (em.value || "").trim();
      if (!v) {
        e.preventDefault();
        msg.className = "nmsg err";
        msg.textContent = T("email_empty", "Please enter your email address.");
        em.focus();
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        e.preventDefault();
        msg.className = "nmsg err";
        msg.textContent = T("email_invalid", "Please enter a valid email address.");
        em.focus();
        return;
      }
      const btn = nf.querySelector("[type=submit]");
      if (btn) {
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");
      }
      msg.className = "nmsg";
      msg.textContent = T("subscribing", "Subscribing…");
    });
    addEventListener("pageshow", () => {
      const btn = nf.querySelector("[type=submit]");
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      }
    });
  }
  const cf = $("#cf");
  if (cf) cf.noValidate = true;
  if (cf) cf.addEventListener("submit", (e) => {
    const n = $("#cn").value.trim(), em = $("#ce").value.trim(), m = $("#cm").value.trim();
    $("#f-cn").classList.toggle("err", !n);
    $("#f-ce").classList.toggle("err", !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em));
    $("#f-cm").classList.toggle("err", !m);
    if ($$("#cf .fld.err").length) e.preventDefault();
  });
  async function loadRecs() {
    for (const box of $$("[data-recs]")) {
      if (box.querySelector(".grid") || !box.dataset.url) continue;
      try {
        const res = await fetch(box.dataset.url);
        if (!res.ok) continue;
        const doc = new DOMParser().parseFromString(await res.text(), "text/html");
        const fresh = doc.querySelector("[data-recs]");
        if (fresh && fresh.innerHTML.trim()) {
          box.innerHTML = fresh.innerHTML;
          reveal(box);
          markFavs();
        }
      } catch (e) {
      }
    }
  }
  window.Lymko = { U, $, $$, reduced, esc, money, toast, addItems, openO, closeAll, reveal, markFavs, store, R, CFG, T, fetchCard, isOpen: () => OPEN };
  document.addEventListener("DOMContentLoaded", () => {
    markFavs();
    renderWishlist();
    recentlyViewed();
    loadRecs();
    reveal();
    onScroll();
    const sc = $("#scrim");
    if (sc) sc.addEventListener("click", () => closeAll());
    if (location.hash === "#cart" || new URLSearchParams(location.search).has("bag")) openO("cart");
    $$('select[name="address[country]"]').forEach((sel) => {
      const d = sel.dataset.default || (CFG.defaultCountry || "India");
      if (d && [...sel.options].some((o) => o.value === d)) sel.value = d;
    });
    const nm = $("#nmsg");
    if (nm && !nm.hasAttribute("data-ok") && /[?&]customer_posted=true/.test(location.search)) {
      nm.className = "nmsg ok";
      nm.textContent = T("subscribed", "✓ Thank you — you’re on the list for exclusive offers.");
    }
  });
  document.addEventListener("shopify:section:load", () => {
    reveal();
    markFavs();
  });
})();
